$(document).ready(function () {
    // Show clinical attachment info if checkbox is selected
    $('#missed-clinical-placement-info').hide();
    $('#missed-clinical-placement').on('change', function () {
        if (this.checked) {
            $('#missed-clinical-placement-info').show();
        } else {
            $('#missed-clinical-placement-info').hide();
        }
    });

    // Show reason description text box if 'other' radio is selected
    $('#other-reason-text-box').hide();
    $('input[name="unplanned-absence-reason"]').on('change', function () {
        if ($('#other-reason').is(':checked')) {
            $('#other-reason-text-box').show();
        } else {
            $('#other-reason-text-box').hide();
        }
    });

    // Show conference details field if checkbox is selected
    $('#conference-details').hide();
    $('#representing-university-at-conference').on('change', function () {
        if (this.checked) {
            $('#conference-details').show();
        } else {
            $('#conference-details').hide();
        }
    });

    $.validator.addMethod('greaterThan',
        function (value, element, params) {
            if (!/Invalid|NaN/.test(new Date(value))) {
                return new Date(value) > new Date($(params).val());
            }
            return isNaN(value) && isNaN($(params).val()) || Number(value) > Number($(params).val());
        }, 'Must be greater than start time/date');

    // Validate absence request form
    var absenceRequestForm = $('#absenceRequestForm');

    $(absenceRequestForm).validate({
        onkeyup: false,
        onclick: false,
        ignore: ':hidden, [contenteditable="true"]:not([name])',
        rules: {
            startdate: {
                required: true,
            },
            enddate: {
                required: true,
                greaterThan: '.absence-start',
            },
            reason: {
                required: true,
                minlength: 15,
            },
            'unplanned-absence-reason': {
                required: true,
            },
            'other-reason-description': {
                required: true,
                minlength: 10,
            },
            'catch-up': {
                required: true,
                minlength: 10,
            },
            recipient: {
                required: true,
            },
        },
        messages: {
            startdate: 'Please choose the start date of your absence',
            enddate: {
                required: 'Please choose the end date of your absence',
                greaterThan: 'Must be greater than start date/time',
            },
            reason: {
                required: 'Please tell us the reason for your absence',
                minlength: 'Reason must be at least 15 characters long',
            },
            'other-reason-description': {
                required: 'Please tell us the reason for your absence',
                minlength: 'Reason must be at least 10 characters long',
            },
            'unplanned-absence-reason': {
                required: 'Please tell us the reason for your absence',
            },
            'catch-up': {
                required: 'Please explain the steps you intend to take to make up for any missed material',
                minlength: 'Explanation must be at least 10 characters long',
            },
            recipient: 'Please select a recipient',
        },
        errorPlacement: function (error, element) {
            // Customise the placement of error messages for the radio buttons
            if (element.attr('name') === 'unplanned-absence-reason') {
                error.appendTo('#reason-radio-buttons .reason-error-message');
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Initialise datetimepicker
    var startDateId = '.absence-start';
    var endDateId   = '.absence-end';

    $('#conditional-form-group, #seven-day-warning, #planned-absence-warning, #planned-absence, .gastro-warning').hide();

    function sevenDaysCheck() {
        if ($(startDateId).val() !== '' && $(endDateId).val() !== '') {
            var startDate = Date.parse($(startDateId).val());
            var endDate   = Date.parse($(endDateId).val());

            if (endDate - startDate > 7 * 86400 * 1000) {
                // If selection covers more than 7 days, show warning and hide form
                $('#seven-day-warning').show();
                $('#conditional-form-group').hide();
            } else {
                // Otherwise hide warning and show form
                $('#seven-day-warning').hide();
                $('#conditional-form-group').show();
            }
        }
    }

    function unplannedAbsenceCheck() {
        var startDate      = dayjs($(startDateId).val(), 'Y/M/D H:mm');
        var todaysDate     = dayjs().startOf('day');
        var warningSpan    = $('#planned-absence-warning').find('span');
        var typeOfAbsence  = $('#type-of-absence');
        var plannedAbsence = $('#planned-absence');
        var gastroWarning  = $('.gastro-warning');
        var reasonTextBox  = $('#reason-text-box, #reason');
        var reasonRadios   = $('#reason-radio-buttons');

        plannedAbsence.hide();

        if (!startDate.isValid()) {
            return;
        }

        if (startDate.isBefore(todaysDate, 'day') || startDate.isSame(todaysDate, 'day')) {
            warningSpan.text('Unplanned Absence').end().show();
            typeOfAbsence.val('Unplanned Absence');
            reasonTextBox.hide();
            reasonRadios.show();
            gastroWarning.show();
        } else {
            warningSpan.text('Planned Absence').end().show();
            typeOfAbsence.val('Planned Absence');
            plannedAbsence.show();
            reasonTextBox.show();
            reasonRadios.hide();
            gastroWarning.hide();
        }
    }

    $(function () {
        $(startDateId).datetimepicker({
            formatDate: 'Y/m/d H:i',
            onGenerate: function (ct) {
                $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
            },
            onShow: function (ct) {
                this.setOptions({
                    maxDate: $(endDateId).val() ? $(endDateId).val() : false,
                });
            },
        });
        $(endDateId).datetimepicker({
            formatDate: 'Y/m/d H:i',
            onGenerate: function (ct) {
                $(this).find('.xdsoft_date.xdsoft_weekend').addClass('xdsoft_disabled');
            },
            onShow: function (ct) {
                this.setOptions({
                    minDate: $(startDateId).val() ? $(startDateId).val() : false,
                });
            },
        });
    });

    $(endDateId).prop('disabled', true);
    $(startDateId).on('change', function () {
        sevenDaysCheck();
        unplannedAbsenceCheck();
        if ($(this).val() === '') {
            if ($(endDateId).prop('disabled') === false) {
                $(endDateId).attr('value', '').val('').prop('disabled', true);
                $(endDateId).datetimepicker('reset');

                setTimeout(function () {
                    $(endDateId).datetimepicker('hide');
                }, 10);
            }
        } else if ($(endDateId).prop('disabled') === true)
            $(endDateId).prop('disabled', false);
    });

    $(endDateId).on('change', function () {
        sevenDaysCheck();
        unplannedAbsenceCheck();
    });

    // Disable submit button after first click to avoid duplicate form submissions
    $('#absenceRequestForm').submit(function () {
        if ($('#absenceRequestForm').valid()) {
            $('#submitButton').prop('disabled', true);
            $('#submitButton').html('<i class="' + FontAwesome.prefix('regular', 'save') + '"></i> Submitting...');
        }
    });
});
